import { render, staticRenderFns } from "./WhsE_Details.vue?vue&type=template&id=679cc1b1"
import script from "./WhsE_Details.vue?vue&type=script&lang=js"
export * from "./WhsE_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports